import { useInstance } from './useInstance.js';
export function useEmit() {
    return useInstance().emit;
}
//# sourceMappingURL=useEmit.js.map